import { isValidPhoneNumber } from "react-phone-number-input";
import { addMethod, string } from "yup";

addMethod(string, "phone", function phone(errorMessage) {
  const errMsg =
    typeof errorMessage === "string" && errorMessage
      ? errorMessage
      : "${path} must be a valid phone number.";

  return this.test("phone", errMsg, (value) => {
    try {
      return isValidPhoneNumber(value);
    } catch (err) {
      console.warn("phone schema:", err);
      return false;
    }
  });
});
